export default "__VITE_ASSET__DRVbIDCj__"